<template>
  <div class="radio-group">
    <label
      class="radio-button"
      :class="{ 'checked-radio-button': button.value === props.value }"
      v-for="(button, i) in buttons"
      :key="i"
      @click="change(button.value)">
      <div class="radio-button-circle"></div>
      <div class="radio-button-text">{{ $t(button.text) }}</div>
      <input :name="name" :value="button.value" type="radio" v-model="props.value">
    </label>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    value: [ Number, String ],
    buttons: Array
  },
  data () {
    return {
      props: {
        value: this.value
      },
      lastValue: this.value
    }
  },
  methods: {
    change (value) {
      if (value === this.lastValue) return
      this.lastValue = value
      this.$emit('change', value)
    }
  }
}
</script>

<style scoped>
input { display: none; }
.radio-group { display: flex; justify-content: space-between; }
.radio-button { align-items: center; border-radius: 5px; cursor: pointer; display: flex; height: 30px; line-height: 30px; padding: 0 8px; position: relative; white-space: nowrap; -webkit-transition: background .3s; -moz-transition: background .3s; -o-transition: background .3s; transition: background .3s; }
.radio-button:hover { background: rgba(0, 0, 0, .05); }
.radio-button-circle { border: 2px solid #713592; border-radius: 6px; display: inline-block; height: 12px; margin-right: 6px; width: 12px; }
.checked-radio-button .radio-button-circle { background: #713592; }
</style>



// WEBPACK FOOTER //
// src/components/forms/RadioGroup.vue